import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageSEO from "@/components/feature/PageSEO";
import HeroSection from "./components/HeroSection";
import FeatureGrid from "./components/FeatureGrid";
import ComicGrid from "./components/ComicGrid";
import StatsSection from "./components/StatsSection";
import TestimonialSection from "./components/TestimonialSection";
import FAQSection from "./components/FAQSection";
import { siteInfo } from "@/mocks/siteInfo";
import { useTranslation } from "react-i18next";

export default function Home() {
  const { t } = useTranslation();

  const faqSchemas = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      { "@type": "Question", name: t("faq.q1", "在线漫画韩漫是免费的吗？"), acceptedAnswer: { "@type": "Answer", text: t("faq.a1") } },
      { "@type": "Question", name: t("faq.q2", "平台有多少部韩漫作品？"), acceptedAnswer: { "@type": "Answer", text: t("faq.a2") } },
      { "@type": "Question", name: t("faq.q3", "支持哪些语言阅读？"), acceptedAnswer: { "@type": "Answer", text: t("faq.a3") } },
      { "@type": "Question", name: t("faq.q4", "漫画更新频率是怎样的？"), acceptedAnswer: { "@type": "Answer", text: t("faq.a4") } },
      { "@type": "Question", name: t("faq.q5", "如何在手机上阅读？"), acceptedAnswer: { "@type": "Answer", text: t("faq.a5") } },
    ],
  };

  const schemas = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteInfo.name,
      url: siteInfo.url,
      description: siteInfo.description,
      contactPoint: { "@type": "ContactPoint", telephone: "+86-400-888-0000", contactType: "customer service", availableLanguage: ["Chinese"] },
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteInfo.name,
      url: siteInfo.url,
      potentialAction: { "@type": "SearchAction", target: siteInfo.url + "/search?q={search_term_string}", "query-input": "required name=search_term_string" },
    },
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: siteInfo.fullName,
      description: siteInfo.description,
      url: siteInfo.url,
      isPartOf: { "@type": "WebSite", name: siteInfo.name, url: siteInfo.url },
    },
    faqSchemas,
  ];

  return (
    <>
      <PageSEO
        title={siteInfo.fullName}
        description={siteInfo.description}
        keywords={siteInfo.keywords}
        canonicalUrl={siteInfo.url}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemas) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <StatsSection />
          <FeatureGrid />
          <ComicGrid />
          <TestimonialSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}